import React from "react";

export default function ProfileQuickLinks({
  activeSection,
  onSectionChange,
  profile,
}) {
  // Use backend-calculated filledSections when available
  const filled = profile?.filledSections || [];
  const isSectionFilled = (sectionName) => filled.includes(sectionName);

  const links = [
    { id: "resume", label: "Resume", action: isSectionFilled("resume") ? "Update" : "Add" },
    { id: "headline", label: "Resume headline", action: isSectionFilled("resume_headline") ? "Edit" : "Add" },
    { id: "skills", label: "Key skills", action: isSectionFilled("key_skills") ? "Edit" : "Add" },
    { id: "employment", label: "Employment", action: isSectionFilled("employment") ? "Edit" : "Add" },
    { id: "education", label: "Education", action: isSectionFilled("education") ? "Edit" : "Add" },
    { id: "itskills", label: "IT skills", action: isSectionFilled("it_skills") ? "Edit" : "Add" },
    { id: "projects", label: "Projects", action: isSectionFilled("projects") ? "Edit" : "Add" },
    { id: "summary", label: "Profile summary", action: isSectionFilled("profile_summary") ? "Edit" : "Add" },
    { id: "accomplishments", label: "Accomplishments", action: isSectionFilled("accomplishments") ? "Edit" : "Add" },
    { id: "career", label: "Career profile", action: isSectionFilled("career_profile") ? "Edit" : "Add" },
    { id: "personal", label: "Personal details", action: isSectionFilled("personal_details") ? "Edit" : "Add" },
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm p-5 sticky top-24">
      <h3 className="font-semibold text-gray-800 mb-4">Quick links</h3>

      <nav className="space-y-1">
        {links.map((link) => (
          <button
            key={link.id}
            onClick={() => {
              onSectionChange(link.id);
              const el = document.getElementById(link.id);
              if (el) {
                const yOffset = -90; // offset for sticky navbar
                const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
              }
            }}
            className={`w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-left transition-colors ${activeSection === link.id
                ? "bg-blue-50 text-blue-600 font-medium"
                : "text-gray-600 hover:bg-gray-50"
              }`}
          >
            <span className="text-sm">{link.label}</span>

            {link.action && (
              <span className="text-blue-600 text-xs font-medium hover:underline">
                {link.action}
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
}
